"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var BrandItemDir = /** @class */ (function (_super) {
    __extends(BrandItemDir, _super);
    function BrandItemDir(props) {
        var _this = _super.call(this, props) || this;
        _this.clickMode = "none";
        return _this;
    }
    BrandItemDir.prototype.componentWillMount = function () {
        this.setState({ bgColor: "#FFFFFF" });
    };
    BrandItemDir.prototype.onMouseEnter = function () {
        this.setState({ bgColor: "#89CFF0" });
    };
    BrandItemDir.prototype.onMouseLeave = function () {
        this.setState({ bgColor: "#FFFFFF" });
    };
    BrandItemDir.prototype.onSelectClick = function () {
        console.log('select click');
        if (this.clickMode === "none") {
            if (this.props.onSelectlick) {
                this.props.onSelectlick(this.props.brandId, this.props.dirName);
            }
        }
    };
    BrandItemDir.prototype.getTitleRenderObject = function () {
        var cssStyle = {
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            borderLeftColor: "transparent",
            borderBottomColor: "transparent",
            borderRightColor: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "157px",
            backgroundColor: "#FFFFFF",
            position: "absolute",
            left: "1px",
            bottom: "0px",
            boxSizing: "border-box"
        };
        return (React.createElement(antd_1.Tooltip, { title: this.props.dirName },
            React.createElement("div", { style: cssStyle },
                React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis" } }, this.props.dirName))));
    };
    BrandItemDir.prototype.render = function () {
        var cssStyle = {
            borderColor: "black",
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "160px",
            height: "160px",
            marginLeft: "5px",
            marginTop: "5px",
            marginRight: "0px",
            marginBottom: "5px",
            backgroundColor: this.state.bgColor,
            cursor: "pointer",
            position: "relative"
        };
        return (React.createElement("div", { style: cssStyle, onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this), onClick: this.onSelectClick.bind(this) },
            React.createElement(antd_1.Icon, { type: "folder", style: { fontSize: "42px" } }),
            this.getTitleRenderObject()));
    };
    return BrandItemDir;
}(React.Component));
exports.default = BrandItemDir;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/dlgSelectBrandImage/controls/BrandItemDir.tsx
// module id = 2393
// module chunks = 0